import { useMemo } from "react";
import type { TargetAndTransition, Transition } from "framer-motion";
import { color, motion as motionTokens, usePrefersReducedMotion } from "@tokens/index";

/**
 * Expand/collapse recipe from the charter: height + fade over 200ms. Spread
 * onto the `motion.div` that is the direct child of an `AnimatePresence`.
 */
export interface ExpandMotionProps {
  readonly initial: TargetAndTransition;
  readonly animate: TargetAndTransition;
  readonly exit: TargetAndTransition;
  readonly transition: Transition;
}

export function useExpandMotion(): ExpandMotionProps {
  const reduced = usePrefersReducedMotion();
  return useMemo<ExpandMotionProps>(() => {
    const transition: Transition = reduced
      ? { duration: motionTokens.reduced.duration }
      : { duration: motionTokens.expand.duration, ease: motionTokens.curves.standard };
    return {
      initial: { opacity: 0, height: 0 },
      animate: { opacity: 1, height: "auto" },
      exit: { opacity: 0, height: 0 },
      transition,
    };
  }, [reduced]);
}

/** Hairline edge shared by every in-page surface on the board. */
export const hairline = `1px solid ${color.border.subtle}`;
